import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { api } from '../lib/api';
import { toast } from 'sonner';

export default function AdminStories() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState('');
  const load = () => api.get('/stories/pending').then(({ data }) => setItems(data.stories)).catch((e) => setErr(e.response?.status === 403 ? 'Admin only.' : 'Could not load'));
  useEffect(() => { load(); }, []);
  const mod = async (id, approve) => { try { await api.post(`/stories/${id}/moderate`, { approve }); toast.success(approve ? 'Published' : 'Rejected'); load(); } catch { toast.error('Failed'); } };
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl font-bold" style={{fontFamily: 'Lexend'}}>Story moderation</h1>
      <p className="text-muted-foreground mt-2">Approve anonymous "approved after appeal" notes before they show on the landing page. Reject anything with names, numbers or unsafe advice.</p>
      {err && <p className="mt-4 text-[#991B1B]" data-testid="admin-stories-error">{err}</p>}
      {items && items.length === 0 && <p className="mt-6 text-muted-foreground" data-testid="admin-stories-empty">No stories waiting for review.</p>}
      <div className="mt-6 space-y-3" data-testid="admin-stories-list">
        {items?.map((s) => (
          <Card key={s.story_id} className="p-4 bg-card" data-testid={`admin-story-${s.story_id}`}>
            <div className="text-xs text-muted-foreground">{s.program} · {s.created_at.slice(0, 10)}</div>
            <p className="mt-1">“{s.text}”</p>
            <div className="mt-3 flex gap-2">
              <Button size="sm" className="bg-primary text-primary-foreground" onClick={() => mod(s.story_id, true)} data-testid={`approve-${s.story_id}`}>Approve</Button>
              <Button size="sm" variant="outline" onClick={() => mod(s.story_id, false)} data-testid={`reject-${s.story_id}`}>Reject</Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
